export default __webpack_public_path__ + "static/media/anvin_thomas.c691d531.jpeg";